(async function () {

    async function removeFreeProduct(id) {
        return fetch(`/cart/change.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: id,
                quantity: 0
            })
        }).then(response => {
            return { success: true };
        }).catch(error => {
            console.error("Error removing free product:", error);
            return { success: false };
        }
        );
    }


    try {
        const { id, limit } = window.free_product_config || {};

        const { items, total_price } = JSON.parse(document.querySelector("#object-cart").textContent) || {};
        const itemsMap = new Map(items.map(item => [String(item.id), item]));
        const hasFreeProduct = !!itemsMap.get(id);
        const hasReachedThreshold = Number(limit) <= total_price;
        const shouldRemoveFreeProduct = hasFreeProduct && !hasReachedThreshold;
        if (shouldRemoveFreeProduct) {
            const response = await removeFreeProduct(id);
            const isSuccess = response.success;
            if (isSuccess) window.location.reload();
        }

    } catch (error) {
        console.error("Error in check-free-product", error);
    }
})();